import type { Module } from "storefront/Contentful/types";

export type Modules = {
  modules: Array<Module>;
};
const modules: Modules = {
  modules: [],
};
export default modules;
